export function toPositiveInt(value, max) {
  let newValue = parseInt(value)
  if (isNaN(newValue) || newValue < 1) newValue = 1
  else if (max && newValue > max) newValue = max
  return newValue
}
